// extracted by mini-css-extract-plugin
export default {"footer":"footer__footer___FPp6_","footerButton":"footer__footerButton___27-Lw","footerMiddleButton":"footer__footerMiddleButton___2Cpkz"};